<template>
	<div>

		<v-toolbar flat fixed>
          <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
          <v-toolbar-title class="white--text">Data Share</v-toolbar-title>
        </v-toolbar>
		
		<div class="hasToolbar">

			<v-alert :value="true" color="info" icon="info" transition="slide-y-transition">
				Data share option allows you to connect and manage your business and its data from a computer.
			</v-alert>

			<v-card flat>
				<v-card-text center-align v-if="connectionCount">
					<div font16 class="pa-4">{{ connectionCount }} {{ connectionCount == 1 ? 'device is' : 'devices are' }} currently connected.</div>
					<!-- <div><v-icon style="font-size:200px;">computer</v-icon></div> -->
					<div><v-btn color="primary" @click="fn_stopService">Disconnect</v-btn></div>
				</v-card-text>

				<v-card-text light-opacity-color center-align v-else>
					<div class="pa-2">No device is currently active.</div>
				</v-card-text>
			</v-card>

			<!-- <v-list nopadding>
				<v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title>Connected Devices {{connectionCount}}</v-list-tile-title>	
                    </v-list-tile-content>
                </v-list-tile>
			</v-list>

            <div class="pa-4 center-align">
                <v-btn color="primary" @click="fn_stopService">Stop Service</v-btn>
            </div> -->
            
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				connectionCount:null
			}
		},
		methods:{

            fn_getConnectionsCount: function(){
				var self = this;
		        this.getData('WebRTCConnectionCount', null, 
		          {
		            onSuccess: function(response){
		              console.log(response);
                      self.connectionCount = response;
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_stopService: function(){
				var self = this;
		        this.getData('CloseWebRTCService', null, 
		          {
		            onSuccess: function(response){
		              console.log(response);
                      self.showToast("Service stopped");
					  self.fn_goBack();
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_goBack: function(){
                this.$router.go(-1);
            },
		},
		mounted: function(){
            window.js_globals.fn_onBackPress = this.fn_goBack;
            this.fn_getConnectionsCount();
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/connection_details.vue